document.addEventListener("DOMContentLoaded", function () {
  // Sticky Header
  const header = document.querySelector('.site-header');
  const scrollThreshold = 1;

  function updateHeaderClass() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  // Check on page load
  updateHeaderClass();

  // Check on scroll
  document.addEventListener("scroll", updateHeaderClass);

  // Mobile Menu
  document.querySelector(".hamburger").addEventListener("click", function () {
    document.body.classList.toggle("menu-active");
    this.classList.toggle("is-active");
  });

  document.querySelectorAll(".subnav .current-item, .subnav__icon").forEach(item => {
    item.addEventListener("click", function () {
      document.querySelector(".subnav nav").classList.toggle("expanded");
    });
  });

  const navLinks = document.querySelectorAll(".nav-link");
  const menu = document.querySelector(".main-menu-mobile"); // Adjust selector for your menu
  const menuToggle = document.querySelector(".navbar-toggler"); // Adjust selector for your menu button
  const body = document.body;

  navLinks.forEach(link => {
    link.addEventListener("click", function () {
      const href = link.getAttribute("href");
      const currentUrl = window.location.origin + window.location.pathname; // Get the current URL without hash

      menu.classList.remove("show");
      body.classList.remove("menu-active");

      if (menuToggle) {
        menuToggle.classList.remove("collapse");
        menuToggle.classList.remove("is-active");
        menuToggle.classList.add("collapsed");
      }
    });
  });
});

